// extracted by mini-css-extract-plugin
export default {"sidebar":"ProfileLeftSidebar_sidebar__fI8Dy"};